import i18n, { type Resource } from "i18next"
import { initReactI18next } from "react-i18next"

import en from "@/shared/locales/en.json"
import pl from "@/shared/locales/pl.json"

export const LANGUAGE_STORAGE_KEY = "erlang-calculator:language"

export const APP_LANGUAGES = ["en", "pl"] as const
export type AppLanguage = (typeof APP_LANGUAGES)[number]

const FALLBACK_LANGUAGE: AppLanguage = "en"

const resources = {
  en: { translation: en },
  pl: { translation: pl },
} satisfies Resource

const sanitizeLanguage = (language?: string | null): AppLanguage => {
  if (language && APP_LANGUAGES.includes(language as AppLanguage)) {
    return language as AppLanguage
  }

  return FALLBACK_LANGUAGE
}

const loadPersistedLanguage = (): AppLanguage => {
  if (typeof window === "undefined") {
    return FALLBACK_LANGUAGE
  }

  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
    return sanitizeLanguage(stored)
  } catch (error) {
    console.warn("Unable to read language preference from localStorage", error)
    return FALLBACK_LANGUAGE
  }
}

void i18n.use(initReactI18next).init({
  resources,
  lng: loadPersistedLanguage(),
  fallbackLng: FALLBACK_LANGUAGE,
  interpolation: { escapeValue: false },
  defaultNS: "translation",
  ns: ["translation"],
  react: { useSuspense: false },
})

export const ensureAppLanguage = sanitizeLanguage
export const fallbackLanguage = FALLBACK_LANGUAGE

export default i18n
